import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-paycheckError',
  templateUrl: './paycheckError.component.html',
  styleUrls: ['./paycheckError.component.scss'] 
})

export class PaycheckErrorComponent implements OnInit {
  paycheckErrorList:any[]=[];
  reCreateState:boolean=false;
  errorStatement:string = 'No worker was found for for the id';
  title: any;

  constructor(private dialogRef: MatDialogRef<PaycheckErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {   
    this.paycheckErrorList= data.list;
    this.title= data.title;
    if(this.title==null || this.title==undefined || this.title=='')
    {
      this.title="Paychex warning(s), please correct and submit again";
    }
  }  
  
  ngOnInit(): void {      
    this.reCreateState = this.paycheckErrorList && this.paycheckErrorList.filter(m=>m.description.indexOf(this.errorStatement)>-1).length>0;    
  }     

  close() {    
    this.dialogRef.close(false);
  }   

  executeReset(){
    this.dialogRef.close(true);
  }
  
}
